import type { BuildBudget, SampleEstimate } from '@/types/custom-playbooks';

/** Why the build waits before another Try, or null when it doesn't. */
export function tryRepairStatus(build?: BuildBudget): string | null {
  if (build?.needsUser) return 'Needs your input';
  if (build?.changeRequired) return 'Change required before another Try';
  return null;
}

/** What the credits can't cover: the org's balance for the whole Try, or a
 *  Try budget that can't fit one record (tryBlockedReason's order). */
export function tryShortfall(
  quote: SampleEstimate
): { of: 'balance' | 'budget'; have: number } | null {
  if (quote.records === 0) return null;
  if (quote.balance < quote.maxCredits)
    return { of: 'balance', have: quote.balance };
  if (quote.build.remainingCredits < quote.maxCreditsByRecords[0])
    return { of: 'budget', have: quote.build.remainingCredits };
  return null;
}
